import { render, staticRenderFns } from "./InventoryIssueResolution.vue?vue&type=template&id=a27143f0&scoped=true"
import script from "./InventoryIssueResolution.vue?vue&type=script&lang=js"
export * from "./InventoryIssueResolution.vue?vue&type=script&lang=js"
import style0 from "./InventoryIssueResolution.vue?vue&type=style&index=0&id=a27143f0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a27143f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a27143f0')) {
      api.createRecord('a27143f0', component.options)
    } else {
      api.reload('a27143f0', component.options)
    }
    module.hot.accept("./InventoryIssueResolution.vue?vue&type=template&id=a27143f0&scoped=true", function () {
      api.rerender('a27143f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inventoryReservation/InventoryIssueResolution.vue"
export default component.exports